import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import createReactClass from 'create-react-class'

import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import Preloader from 'legacy/libs/components/preloader'
import SelectableRegion from 'legacy/apps/region/components/selectable-gis-region'

import { withGettext } from 'lib/gettext'
import s from './select-region-input.module.scss'

const SelectRegionInput = createReactClass({
  mixins: [BranchMixin, FormComponentMixin],

  propTypes: {
    ngettext: PropTypes.func.isRequired,
    gettext: PropTypes.func.isRequired,
    regions: PropTypes.shape({
      isLoading: PropTypes.bool,
      data: PropTypes.arrayOf(PropTypes.object),
    }),
  },

  cursors(props, context) {
    return {
      value: this.getCursor(props, context),
    }
  },

  render() {
    const { regions, ngettext, gettext } = this.props
    const regionsCount = regions.data ? regions.data.length : 0

    return (
      <Preloader isLoading={regions.isLoading}>
        <div className={s.container}>
          <div className={s.results}>
            {regionsCount ? (
              <div>
                <div className={s.count}>
                  {ngettext(
                    '%(count)i result found',
                    '%(count)i results found',
                    regionsCount
                  )}
                </div>
                <div className={s.list}>
                  {_.map(regions.data, (region, index) => (
                    <SelectableRegion
                      region={region}
                      key={index}
                      selected={_.get(this.state.value, 'pk') === region.pk}
                      onSelect={this.setValue}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className={s.no__results}>{gettext('No results found')}</div>
            )}
          </div>
        </div>
      </Preloader>
    )
  },
})

export default withGettext(SelectRegionInput)
